export const commons = [
    'T',
    'TX',
    'TN',
    'U',
    'UN',
    'UX',
    'RR',
    'FF',
    'FXY',
    'DD',
    'T_SOIL',
    'T_DEW'
];
export const measurements = [
    /** Drainage */
    'DRN',
    /** Wind direction */
    'DXY',
    /** Hydric deficit */
    'HDEF',
    /** Hydric potential */
    'HPOT',
    /** Calibration temperature */
    'T_CAL',
    'T_DRY',
    'T_WET',
    /** Leaf Wetness Voltage */
    'LW_V',
    /** Leaf Wetness Duration */
    'LW_D',
    /** Heat accumulation in degrees day (front-end only metric) */
    'heatAccumulation',
    'RRAccumulation',
    /** Cumulative sunshine hours (front-end only metric) */
    'SSI_HOURSAccumulation',
    /** Rainfall intensity (front-end only metric) */
    'rainfallIntensity',
    'CAPA',
    'T_CAPA',
    'U_CAPA',
    'VOLT',
    'COLD_T_HOUR',
    /** Solar Radiation */
    'SSI',
    'SSI_MIN',
    'SSI_MAX',
    /** Hours of sunshine */
    'SSI_HOURS',
    /** PPFD */
    'PPFD',
    'PPFD_MIN',
    'PPFD_MAX',
    /** Irrigation */
    'IRR',
    // Water electro conductivity
    'ECP',
    // Vapor Pressure Deficit
    'VPD',
    // soil water content
    'SWC'
];
export const forecasts = [
    /** Cloud cover */
    'CLDC',
    /** Evapotranspiration */
    'etp',
    'icon_code',
    'delay_without_rain',
    'phrase_32char',
    'pop_phrase'
];
/** List of metrics allowing min & max aggregates */
export const aggregateEnabledMetrics = ['FF', 'T', 'U', 'T_WET', 'T_DRY', 'T_SOIL'];
export const isAggregateEnabledMetric = (value) => {
    return aggregateEnabledMetrics.includes(value);
};
/** Metrics used to represent hydric stress (hydric potential for tensiometers and water level for capacitive) */
export const hydricStressMetrics = ['HPOT', 'U_CAPA'];
export const isHydricStress = (value) => {
    return hydricStressMetrics.includes(value);
};
export const frostMetrics = ['T_WET', 'T_DRY'];
export const isFrost = (value) => {
    return frostMetrics.includes(value);
};
export const isForecast = (value) => {
    return forecasts.includes(value) || commons.includes(value);
};
export const isMeasurement = (value) => {
    return measurements.includes(value) || commons.includes(value);
};
export function isMetricAggregates(metric) {
    return (metric.endsWith('-min') ||
        metric.endsWith('-max') ||
        metric === 'FXY' ||
        metric === 'TX' ||
        metric === 'TN' ||
        metric === 'UX' ||
        metric === 'UN');
}
export const metricByAggregate = {
    'FF-max': 'FF',
    'FF-min': 'FF',
    'T-max': 'T',
    'T-min': 'T',
    'T_DRY-max': 'T_DRY',
    'T_DRY-min': 'T_DRY',
    'T_SOIL-max': 'T_SOIL',
    'T_SOIL-min': 'T_SOIL',
    'T_WET-max': 'T_WET',
    'T_WET-min': 'T_WET',
    'U-max': 'U',
    'U-min': 'U',
    FXY: 'FF',
    TN: 'T',
    TX: 'T',
    UN: 'U',
    UX: 'U'
};
export const metricsWithHorizon = ['T_CAL', 'HPOT', 'U_CAPA', 'T_CAPA', 'CAPA'];
export const metricsWithEditableHorizon = ['T_CAL', 'HPOT'];
export const isMetric = (metric) => {
    return (commons.includes(metric) ||
        forecasts.includes(metric) ||
        measurements.includes(metric));
};
export const isNotAggregation = (metric) => {
    return !(metric.endsWith('N') ||
        metric.endsWith('-min') ||
        metric.endsWith('X') ||
        metric.endsWith('-max'));
};
/** U_CAPA is a special case since it is both inside {@link MetricsWithHorizon} & {@link MetricsWithoutHorizon} when we pass the {@link HistoryAggregateQueryParams.aggregateByMetric} query param to true */
export const metricsWithAndWithoutHorizon = ['U_CAPA'];
export const isMetricWithHorizon = (value, aggregateByMetric) => {
    /** See {@link metricsWithAndWithoutHorizon} */
    const isAggU_CAPA = aggregateByMetric && value === 'U_CAPA';
    return isAggU_CAPA ? false : metricsWithHorizon.includes(value);
};
export const metricNotSupportedInExport = [
    'RRAccumulation',
    'heatAccumulation',
    'SSI_HOURSAccumulation',
    'rainfallIntensity',
    'TN',
    'TX',
    'UN',
    'UX',
    'VOLT',
    'CAPA',
    'COLD_T_HOUR',
    'SSI_HOURS'
];
export const isMetricCompatibleWithExport = (metric) => {
    return !metricNotSupportedInExport.includes(metric);
};
export const isMetricThatNeedsToBeFromDeviceToBeDisplayedOnMap = (metric) => ['PPFD', 'PPFD_MAX', 'PPFD_MIN', 'SSI', 'SSI_MAX', 'SSI_MIN'].includes(metric);
export const isMetricVisibleOnWeatherMapSummary = (metric) => ['RR', 'T', 'U', 'FF', 'T_WET', 'T_DRY', 'T_SOIL', 'PPFD', 'SSI', 'LW_V'].includes(metric);
export const fertigationMetrics = ['SWC', 'ECP'];
export const isFertigationMetric = (metric) => {
    return fertigationMetrics.includes(metric);
};
export const metricsAndLabelKeyDisplayedByMetric = (metric) => {
    const coreMetric = (metric) => metric.replace('_MAX', '').replace('_MIN', '');
    switch (metric) {
        case 'RR':
            return {
                RR_D: 'periods.today',
                RR_DD: 'periods.last_day',
                RR_7D: 'periods.last_7_days_abbr'
            };
        case 'T':
        case 'U':
        case 'T_SOIL':
        case 'ECP':
        case 'SWC':
            return {
                [metric + '_L']: 'map.universes.aggregate.real-time',
                [metric + '_N']: 'map.universes.aggregate.min-measured-today',
                [metric + '_X']: 'map.universes.aggregate.max-measured-today'
            };
        case 'PPFD':
        case 'PPFD_MAX':
        case 'PPFD_MIN':
        case 'SSI':
        case 'SSI_MAX':
        case 'SSI_MIN':
            return {
                [coreMetric(metric) + '_L']: 'map.universes.aggregate.real-time',
                [coreMetric(metric) + '_MIN_L']: 'map.universes.aggregate.real-time-PPFD_MIN',
                [coreMetric(metric) + '_MAX_L']: 'map.universes.aggregate.real-time-PPFD_MAX'
            };
        case 'FF':
        case 'FXY':
        case 'DD':
            return {
                FF_L: 'wind.average',
                FXY_L: 'wind.gust',
                DD_L: 'wind.direction'
            };
        case 'T_WET':
        case 'T_DRY':
            return {
                T_WET: 'map.universes.frost.wet_temperature_abbr',
                T_DRY: 'map.universes.frost.dry_temperature_abbr'
            };
        case 'HPOT':
        case 'U_CAPA':
            return {
                [metric + '_7D']: 'map.universes.aggregate.d-7-measure',
                [metric + '_DD']: 'map.universes.aggregate.d-1-measure',
                [metric + '_D']: 'map.universes.aggregate.d-0-measure',
                [metric + '_L']: 'map.universes.aggregate.real-time'
            };
        case 'HDEF':
            return {
                [metric + '_D']: 'map.universes.aggregate.d-0-measure',
                [metric + '_DD']: 'map.universes.aggregate.d+1-measure',
                [metric + '_3D']: 'map.universes.aggregate.d+3-measure',
                [metric + '_5D']: 'map.universes.aggregate.d+5-measure'
            };
        case 'LW_V':
        case 'LW_D':
            return {
                LW_V_L: 'metrics.intensity',
                LW_D_4H: 'map.universes.aggregate.cumul-measured-4H',
                LW_D_12H: 'map.universes.aggregate.cumul-measured-12H'
            };
        case undefined:
            return {};
        default:
            return {};
    }
};
